import { RECURRENCE_INTERVALS, type RecurrenceIntervalValue } from "@gladis/shared";
import { t } from "@gladis/ui/i18n";

/**
 * How each interval is written for a reader.
 *
 * Presentation, so it lives under `ui/` and never reaches `apps/api`, which imports the `.` entry
 * point only. The VALUES come from the kernel; only the wording is here, so a seventh interval
 * cannot be added to a picker without existing in the ratio table first.
 */
/*
 * THE WORDS MOVED TO `@gladis/ui/i18n` — feature 021, and this file is where the cost of the old
 * shape showed. It held six English constants evaluated at import: frozen in whichever language
 * loaded first, and invisible to a sweep of `.tsx` files, which is why they were the last strings in
 * the product still rendering in English after every component had been migrated.
 *
 * The expenses module keeps its own copy of the SET, because it also carries preview ratios — but
 * both now resolve the same six keys, so the two lists cannot say different words for one interval.
 */
export function intervalLabel(value: RecurrenceIntervalValue): string {
  return t(`interval.${value}`);
}

/**
 * The six, in the order a picker offers them — most frequent first, as the Expenses form does.
 *
 * A FUNCTION, not a constant. A module-scope array would bake the labels in at import.
 */
export function intervalOptions(): { value: RecurrenceIntervalValue; label: string }[] {
  return RECURRENCE_INTERVALS.map((value) => ({ value, label: intervalLabel(value) }));
}
